import Header from "./Header";
import Footer from "./Footer";
import { getCMSSectionContent } from "../../api/commonApi";
import { useEffect, useState } from "react";
import DOMPurify from "isomorphic-dompurify";

const PrivacyPolicy = () => {
  const [html, setHtml] = useState(""); // <- no <string>

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await getCMSSectionContent("privacyPolicy");
        const raw = response?.data?.content1 ?? "";
        setHtml(DOMPurify.sanitize(raw));
      } catch (error) {
        console.error("Error loading terms and conditions:", error);
      }
    };
    fetchContent();
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <div className="sticky top-0 z-50 shadow-md">
        <Header />
      </div>

      <main className="flex-1 bg-white aptos-override text-gray-800">
        <section className="max-w-4xl mx-auto px-6 py-12 pt-28 md:pt-32 scroll-mt-28">
          <h1 className="heading-style mb-4">
            <span className="heading-style text-[#87004C]">Privacy</span> Policy
          </h1>

          <div
            className="prose prose-gray max-w-none"
            dangerouslySetInnerHTML={{ __html: html }}
          />
          {!html && (
            <p className="text-gray-500 mt-4">Loading terms and conditions…</p>
          )}
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
